import React, { useContext, useState, useEffect } from "react";
import { Button, Input, DatePicker, Tooltip } from "antd";
import axios from "axios";
import { AuthContext } from "../../../../contexts/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import LoadingAction from "../../../../themes/LoadingAction/LoadingAction";
import question_icon from "../../../../assets/images/question.png";
import { FaArrowLeft } from 'react-icons/fa';
import moment from "moment";

const AddCliente = (props) => {

  const styles = `
  .Maquinas-page {
    background-color: black;
    color: white; 
    margin: 0; 
    padding: 0; 
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    height: 100vh;
    height: 100dvh;
    min-height: 100vh;
    min-height: 100dvh;
    width: 100vw;
    overflow: auto;   
  }
  .AddCliente_header {
  display: flex; 
  align-items: center; 
  justify-content: flex-start; 
  margin: 10px 20px 20px 20px;
  gap: 30px; 
  }
  .AddCliente_header_title {
  background-color: transparent !important;
  color: rgb(250, 247, 83) !important;
  border-radius: 5px !important;
  text-align: left !important;
  line-height: 1 !important;
  height: auto; 
  display: flex !important;
  align-items: center !important;
  font-size: 30px;
  margin-top: 50px;
  }
  .Botao-Voltar {
  font-size: 20px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 10px;
  border: none;
  font-weight: bold;
  background-color: rgb(163, 3, 163);
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 50px;
  border: 1px solid #ffffff;
  }
  .Botao-Voltar:hover {
  background-color: rgb(250, 31, 250);
  }
  .AddCliente_content {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 400px;
    padding: 30px;
    }
    .AddCliente_itemField {
    padding: 10px 0px;
    width: 100%;
    }
    .AddCliente_itemFieldLabel {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    }
    .AddCliente_itemField input {
    border: 1px solid #55b962;
    border-radius: 4px;
    background-color: rgba(250, 248, 248, 0.98);
    }
    .AddCliente_itemField input .AddCliente_inputError {
    border: 1px solid #e46772;
    }
  .Botao-Salvar {
    margin-top: 20px;
    background-color:rgb(6, 128, 2);
    color: #fff;
    border-radius: 4px;
    width: 100%;
    border: 1px solid #ffffff;
    display: flex; 
    align-items: center; 
    justify-content: center; 
    text-align: center;
    font-size: 20px;
    font-weight: bold;
  }
  .Botao-Salvar:hover {
    background-color:rgb(78, 247, 100);
    color: #fff;
  }
    .AddCliente_itemFieldError {
    color: #e46772;
    font-size: 14px;
    padding: 2px 0;
    }
    .AddCliente_Label_Icon {
    cursor: pointer;
    display: flex;
    align-items: center;
    }
    .AddCliente_Icon {
    width: 22px;
    margin-left: 10px;
    margin-bottom: 0.5rem;
    }
    .AddCliente_Reload_Icon {
    cursor: pointer;
    }
    .add-maquina {
      background-color: #0056b3;
      color: white;
      padding: 20px;
      text-decoration: none;
      border-radius: 8px;
    }  
  .AddCliente_itemField .ant-picker {
     width: 100%;
  }
 @media only screen and (max-width: 760px) and (orientation: portrait) {
  .AddCliente_header {
    flex-direction: column; /* Mantém os elementos em coluna */
    align-items: center; /* Centraliza tudo horizontalmente */
    gap: 15px; /* **Aumenta o espaçamento entre os elementos** */
    margin: 20px 20px 10px 20px; /* **Empurra um pouco o título para baixo** */
  }
  .AddCliente_header_title {
    margin: 10px auto 15px auto !important;
    text-align: center !important; 
    width: 100%; 
    font-size: 24px; 
    line-height: 1.2; 
    display: flex; 
    justify-content: center; 
  }
  .Botao-Voltar {
    width: 100%; 
    margin: 0 auto; 
    padding: 20px;
    box-sizing: border-box; 
    display: flex; 
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-bottom: 5px; 
  }
  .Botao-Salvar {
    display: flex; 
    align-items: center; 
    justify-content: center;
    text-align: center;
  }
  .AddCliente_content {
    margin-top: 0 !important;
    padding-top: 5px !important;
  }
 }
}
  `;

    useEffect(() => {
      const styleSheet = document.createElement("style");
      styleSheet.type = "text/css";
      styleSheet.innerText = styles;
      document.head.appendChild(styleSheet);
  
      return () => {
        document.head.removeChild(styleSheet);
      };
    }, [styles]);


  const { authInfo, setNotiMessage } = useContext(AuthContext);
  const navigate = useNavigate();
  const token = authInfo?.dataUser?.token;

  const dateFormat = "YYYY-MM-DD";
  let currentDate = moment();

  const [data, setData] = useState({
    nome: "",
    email: "",
    senha: "",
    mensalidade: "",
    telefone: "",
    mercadoPagoToken: "",
    dataVencimento: currentDate.add(1, "month"), //  Vencimento após 1 mês - BELINI
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const handleChange = (name, value) => {
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => {
      let errorsTemp = { ...prev };
      delete errorsTemp[name];
      return errorsTemp;
    });
  };

  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const onSave = () => {
    // Validação dos campos obrigatórios
    let errorsTemp = {};
    if (data.nome.trim() === "") {
      errorsTemp.nome = "Este campo é obrigatório";
    }
  
    if (!validateEmail(data.email)) {
      errorsTemp.email = "Este campo é obrigatório";
    }
  
    if (data.telefone.trim().length < 12) {
      errorsTemp.telefone = "Precisa ter código do país e código de área";
    }
  
    if (data.mensalidade.trim().length < 1) {
      errorsTemp.mensalidade = "Este campo é obrigatório";
    }
  
    if (data.senha.trim().length < 6) {
      errorsTemp.senha = "A senha deve possuir no mínimo 6 dígitos.";
    }
  
    if (Object.keys(errorsTemp).length > 0) {
      setErrors(errorsTemp);
      return;
    }
  
    setIsLoading(true);
  
    // Log dos dados que serão enviados
    // console.log("Enviando os seguintes dados para criação do cliente:", {
    //  nome: data.nome,
    //  email: data.email,
    //  senha: data.senha.trim(),
    //  mensalidade: data.mensalidade.trim(),
    //  telefone: data.telefone.trim(),
    //  mercadoPagoToken: data.mercadoPagoToken.trim(),
    //  dataVencimento: new Date(data.dataVencimento),
    // });
  
    axios
      .post(
        `${process.env.REACT_APP_SERVIDOR}/cliente`,
        {
          nome: data.nome,
          email: data.email,
          senha: data.senha.trim(),
          mensalidade: data.mensalidade.trim(),
          telefone: data.telefone.trim(),
          mercadoPagoToken: data.mercadoPagoToken.trim(),
          dataVencimento: new Date(data.dataVencimento),
        },
        {
          headers: {
            "x-access-token": token,
            "content-type": "application/json",
          },
        }
      )
      .then((res) => {
        setIsLoading(false);
        navigate("/dashboard-clientes");
      })
      .catch((err) => {
        setIsLoading(false);
        setNotiMessage({
          type: "error",
          message: err.response?.data?.error
            ? err.response?.data?.error
            : `Sua sessão expirou, faça login novamente. 01`,
        });
      });
  };
  
  const handleGeneratePassword = () => {
    handleChange("senha", String(Math.floor(100000 + Math.random() * 9000)));
  };

  return (
    <>
      {isLoading && <LoadingAction />}
      <div className="Maquinas-page">
        <div className="AddCliente_header">
          <div className="AddCliente_header_title">CADASTRO DE CLIENTE</div>
          <Button className="Botao-Voltar" onClick={() => navigate("/dashboard-clientes")} >
            <FaArrowLeft />
            VOLTAR
          </Button>
        </div>
        <div className="AddCliente_content">
          <div className="AddCliente_itemField">
            <label className="AddCliente_itemFieldLabel" htmlFor="nome">
              Cadastrar Nome:
            </label>
            <Input
              placeholder={"Jukinha da Silva"}
              value={data.nome}
              id="nome"
              type="text"
              name="nome"
              autoComplete="nome"
              onChange={(event) => {
                handleChange("nome", event.target.value);
              }}
              className={`${!!errors.nome ? "AddCliente_inputError" : ""}`}
            />
            {errors.nome && (
              <div className="AddCliente_itemFieldError">{errors.nome}</div>
            )}
          </div>

          <div className="AddCliente_itemField">
            <label className="AddCliente_itemFieldLabel" htmlFor="email">
              Cadastrar Email:
            </label>
            <Input
              placeholder={"Jukinha@gmail.com"}
              value={data.email}
              id="email"
              type="email"
              name="email"
              autoComplete="email"
              onChange={(event) => {
                handleChange("email", event.target.value);
              }}
              className={`${!!errors.email ? "AddCliente_inputError" : ""}`}
            />
            {errors.email && (
              <div className="AddCliente_itemFieldError">{errors.email}</div>
            )}
          </div>

          <div className="AddCliente_itemField">
            <label
              className="AddCliente_itemFieldLabel"
              htmlFor="mercadoPagoToken"
            >
              Cadastrar Senha:
            </label>
            <Input
              placeholder={"********"}
              value={data.senha}
              id="senha"
              type="text"
              name="senha"
              autoComplete="senha"
              onChange={(event) => {
                handleChange("senha", event.target.value);
              }}
              className={`${!!errors.senha ? "AddCliente_inputError" : ""}`}
            />
            {errors.senha && (
              <div className="AddCliente_itemFieldError">{errors.senha}</div>
            )}
          </div>

          <div className="AddCliente_itemField">
            <div className="AddCliente_Label_Icon">
              <label
                className="AddCliente_itemFieldLabel"
                htmlFor="mercadoPagoToken"
              >
                Cadastrar Token:
              </label>
              <img
                src={question_icon}
                alt="question icon"
                className="AddCliente_Icon"
                onClick={() =>
                  navigate("/token-help-page", {
                    state: { redirect_url: `/novo-cliente` },
                  })
                }
              />
            </div>
            <Input
              placeholder={"APPMP123123-12312-123123"}
              value={data.mercadoPagoToken}
              id="mercadoPagoToken"
              type="text"
              name="mercadoPagoToken"
              autoComplete="mercadoPagoToken"
              onChange={(event) => {
                handleChange("mercadoPagoToken", event.target.value);
              }}
              className={`${!!errors.mercadoPagoToken ? "AddCliente_inputError" : ""
                }`}
            />
            {errors.mercadoPagoToken && (
              <div className="AddCliente_itemFieldError">
                {errors.mercadoPagoToken}
              </div>
            )}
          </div>

          <div className="AddCliente_itemField">
            <label className="AddCliente_itemFieldLabel" htmlFor="mensalidade">
              Valor da Mensalidade:
            </label>
            <Input
              placeholder={"35"}
              value={data.mensalidade}
              id="mensalidade"
              type="number"
              name="mensalidade"
              autoComplete="mensalidade"
              onChange={(event) => {
                handleChange("mensalidade", event.target.value);
              }}
              className={`${!!errors.mensalidade ? "AddCliente_inputError" : ""
                }`}
            />
            {errors.mensalidade && (
              <div className="AddCliente_itemFieldError">
                {errors.mensalidade}
              </div>
            )}
          </div>

          <div className="AddCliente_itemField">
            <label className="AddCliente_itemFieldLabel" htmlFor="telefone">
              Telefone para Mensagens:
            </label>
            <Input
              placeholder={"5537920007857"}
              value={data.telefone}
              id="telefone"
              type="number"
              name="telefone"
              autoComplete="telefone"
              onChange={(event) => {
                handleChange("telefone", event.target.value);
              }}
              className={`${!!errors.telefone ? "AddCliente_inputError" : ""
                }`}
            />
            {errors.telefone && (
              <div className="AddCliente_itemFieldError">
                {errors.telefone}
              </div>
            )}
          </div>

          <div className="AddCliente_itemField">
            <div className="AddCliente_label_Icon">
              <label
                className="AddCliente_itemFieldLabel"
                htmlFor="mercadoPagoToken"
              >
                Vencimento da Mensalidade:
              </label>
              <Tooltip title="A data de vencimento do cliente é uma data que após 10 dias é feito a trava das máquinas do cliente para receber pagamentos. Ideal para quem cobra mensalidade, se não definida por padrão colocamos 1 (um) ano. se não quiser usar coloque uma data maior">
                <img
                  src={question_icon}
                  alt="question icon"
                  className="AddCliente_Icon"
                />
              </Tooltip>
            </div>
            <DatePicker
              placeholder={data.dataVencimento}
              style={{ color: "black" }}
              className={`custom-datepicker ${!!errors.dataVencimento ? "AddCliente_inputError" : ""
                }`}
              defaultValue={data.dataVencimento}
              format={"YYYY-MM-DD"}
              id="dataVencimento"
              name="dataVencimento"
              autoComplete="dataVencimento"
              onChange={(vl, dateString) => {
                handleChange("dataVencimento", dateString);
              }}
            />
            {errors.dataVencimento && (
              <div className="AddCliente_itemFieldError">
                {errors.dataVencimento}
              </div>
            )}
          </div>

          <Button
            onMouseEnter={(e) => (e.target.style.color = "#fff")}
            onMouseLeave={(e) => (e.target.style.color = "#fff")}
            className="Botao-Salvar"
            onClick={() => {
              if (!isLoading) onSave();
            }}
            disabled={isLoading}
          >
            FINALIZAR CADASTRO
          </Button>
        </div>
      </div>
    </>
  );
};

export default AddCliente;
